import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {
        info: {
            "siteId": "d52e96db-23de-4ff9-b9ec-82e65e9515fa",
            "siteName": "Acme Corporation"
        },
        countryDomain: {
            "countryIndex": 216
        },
        timeConfig: {
            "timezone": "Asia/Taipei",
            "ntpServer1": "time.google.com",
            "ntpServer2": "",
            "ntpServer3": ""
        },
        deviceAccount: {
            "userName": "org_inventory_admin",
            "password": "OrgSecurePass2025!"
        }
    }
};

export const siteGeneralSlice = createSlice({
    name: "siteGeneral",
    initialState,
    reducers: {
        updateSiteGeneral: (state, action) => {
            state.data = action.payload.data;
        },
    },
});

export const { updateSiteGeneral } = siteGeneralSlice.actions;

export default siteGeneralSlice.reducer;